import { render } from "./LiveForm.vue?vue&type=template&id=16bb7986"
import script from "./LiveForm.vue?vue&type=script&lang=js"
export * from "./LiveForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LiveForm.vue?vue&type=style&index=0&id=16bb7986&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__